import usePlatformStore from "./usePlatformStore";

/**
 * Composable to expose information about how to render the default layout based on the query parameters and the platform configuration
 */
export const useLayout = () => {
  const route = useRoute();
  const platformStore = usePlatformStore();

  const isGiveawayPage = useState<boolean>("isGiveawayPage", () => false);
  const isLayoutDisabled = useState<boolean>("isLayoutDisabled", () => false);
  const previouslyVisitedPagePath = useState<string | null>(
    "previouslyVisitedPagePath",
    () => null,
  );

  onMounted(() => {
    if (route.query.layout === "true") {
      isLayoutDisabled.value = false;
    } else if (!isLayoutDisabled.value) {
      isLayoutDisabled.value = route.query.layout === "false";
    }
  });

  // Only allow setting of layout disabled if the url does not already contain this.
  // This way we can control the layout disabled from the inside if needed without intervening
  // when it's actually set from the outside
  const setIsLayoutDisabled = (newStatus: boolean) => {
    if (route.query.layout !== "false") {
      isLayoutDisabled.value = newStatus;
    }
  };

  const setIsGiveawayPage = (newStatus: boolean) => {
    isGiveawayPage.value = newStatus;
  };

  const setPreviouslyVisitedPagePath = (pagePath: string | null) => {
    previouslyVisitedPagePath.value = pagePath;
  };

  const { getStyleFromTheme } = useGetStyleFromTheme();
  const platformStyles = computed(() => {
    return getStyleFromTheme(platformStore.getPlatformConfiguration.styling);
  });

  return {
    /**
     * To be able to render a bare-bones version of the page.
     * Mainly meant to be used by the Native app to render the web page for some routes
     */
    isLayoutDisabled: readonly(isLayoutDisabled),
    isGiveawayPage: readonly(isGiveawayPage),
    previouslyVisitedPagePath: readonly(previouslyVisitedPagePath),
    setIsLayoutDisabled,
    setIsGiveawayPage,
    setPreviouslyVisitedPagePath,
    platformStyles,
  };
};
